import { Config } from './typings/Config'
import {
  ZonePage,
  PositionPage,
  AlmacenPage,
  UserPage,
  PickingPage,
  PickingValidatePage,
  ProcessNew,
  WorkOrderDashboardPage,
  DashBoardPage,
  FillRatePage,
  // StockMovementPage,
  StockMovementNewPage,
  ConfigurationPage,
  // DispatchOtPage,
  // OtInboundDifferencePage,
  // RelocatePage,
  CheckPage,
  TypePositionPage,
  ReturnsPage,
  PositionAlertsPage,
  WorkOrderOutboundPage,
  ProductOriginPage,
  PickingRouteAdminPage,
  TypePriorityPage,
  ASNAdjustmentPage
  // SupplierOriginPage as OldSupplierOriginPage
} from './pages/'

import {
  SUPER_ADMIN,
  ADMIN_CONFIGURATOR,
  PICKER,
  WAREHOUSE_SUPERVISOR,
  PUTAWAY,
  DISPATCHER,
  ADMUSER
} from './config/roles'
import { OtInboundPage } from './pages/Planner/OtInboundPage'
import { PickingReportPage } from './pages/PickingReport/PickingReportPage'
import { PutAwayPage } from './pages/PutAway/PutAwayPage'
import { KardexPage } from './pages/Kardex/KardexPage'
import { StockReservePage } from './pages/StockReserve/StockReservePage'
import { PreSaleSkuPage } from './pages/PreSaleSku/PreSaleSkuPage'
import { CourierPage } from './pages/Courier/CourierPage'
import { WebhookPage } from './pages/Webhook/WebhookPage'
import { ASNReceptionPage } from './pages/ASNReception/ASNReceptionPage'
import { NewStockPages } from './pages/Stock/NewStockPages'
import { ExternalAuditPage } from './pages/ExternalAudit/ExternalAuditPage'
import { NewProductPage } from './pages/Productos/NewProductPage'
import { InventoryCheckPage } from './pages/InventoryCheck/InventoryCheckPage'
import InventoryCheckHandheldPage from './pages/InventoryCheckHandheld/InventoryCheckPage'
import { WorkOrderRecallPage } from './pages/WorkOrderRecall/WorkOrderRecallPage'
import { RestockOrderPage } from './pages/RestockOrder/RestockOrderPage'
import { DispatchOtNewPage } from './pages/DispatchOtNew'
import { SupplierPage } from './pages/Supplier20'
import { ASNPage } from './pages/ASN20'
import { AsnDetailsQueryPage } from './pages/AsnDetailsQuery'
// import { ASNPage as OldASNPage } from './pages/ASN/ASNPage'
import { SupplierOriginPage } from './pages/SupplierOrigin20/SupplierOriginPage'
import NewRelocatePage from './pages/NewRelocate/NewRelocatePage'
// import { PlannerPage } from './pages/Planner/PlannerPage'
import { OrderPage } from './pages/OrderPage'
import { PackingListNewPage } from './pages/PackingList/PackingListNewPage'

const style = {
  identation: '10px'
}

export const configuration: Config = {
  name: 'wms',
  iconUrl: 'wms',
  url: '/wms',
  visibleName: 'WMS',
  submenus: [
    // INGRESO DE MERCADERIA
    {
      component: undefined,
      name: 'Ingreso Mercadería',
      url: '',
      roles: [SUPER_ADMIN],
      items: [
        {
          component: SupplierPage,
          name: 'Gestionar Proveedor',
          url: 'merchandise/supplier',
          roles: [SUPER_ADMIN, ADMIN_CONFIGURATOR],
          identation: style.identation
        },
        {
          component: SupplierOriginPage,
          name: 'Gestionar Origen',
          url: 'merchandise/origin',
          roles: [SUPER_ADMIN, ADMIN_CONFIGURATOR],
          identation: style.identation
        },
        // {
        // component: OldSupplierPage,
        //  name: 'Gestionar Proveedor',
        //  url: 'merchandise/oldsupplier',
        //  roles: [SUPER_ADMIN, ADMIN_CONFIGURATOR],
        //  identation: style.identation
        // },
        // {
        //  component: OldSupplierOriginPage,
        //  name: 'Gestionar Origen',
        //  url: 'merchandise/oldorigin',
        //  roles: [SUPER_ADMIN, ADMIN_CONFIGURATOR],
        //  identation: style.identation
        // },
        // {
        //  component: OldSupplierPage,
        //  name: 'Gestionar Proveedor',
        //  url: 'merchandise/oldsupplier',
        //  roles: [SUPER_ADMIN, ADMIN_CONFIGURATOR],
        //  identation: style.identation
        // },
        // {
        //  component: OldSupplierOriginPage,
        //  name: 'Gestionar Origen',
        //  url: 'merchandise/oldorigin',
        //  roles: [SUPER_ADMIN, ADMIN_CONFIGURATOR],
        //  identation: style.identation
        // },
        {
          component: PackingListNewPage,
          name: 'Gestionar Packing List',
          url: 'merchandise/newpackinglist',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        },
        {
          component: ASNPage,
          name: 'Gestionar ASN',
          url: 'merchandise/asn',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        },
        {
          component: AsnDetailsQueryPage,
          name: 'Detalle de ASN',
          url: 'merchandise/asndetails',
          roles: [WAREHOUSE_SUPERVISOR, PUTAWAY],
          identation: style.identation
        },
        // {
        //  component: OldASNPage,
        //  name: 'Gestionar ASN',
        //  url: 'merchandise/oldasn',
        //  roles: [WAREHOUSE_SUPERVISOR],
        //  identation: style.identation
        // },
        {
          component: ASNReceptionPage,
          name: 'Recepcionar LPN',
          url: 'merchandise/reception',
          roles: [PUTAWAY],
          identation: style.identation
        },
        {
          component: PutAwayPage,
          name: 'Ubicar Productos',
          url: 'merchandise/ubication',
          roles: [PUTAWAY],
          identation: style.identation
        },
        // {
        //  component: OtInboundDifferencePage,
        //  name: 'Ajustar ASN',
        //  url: 'merchandise/adjustment',
        //  roles: [PUTAWAY],
        //  identation: style.identation
        // },
        {
          component: ASNAdjustmentPage,
          name: 'Ajustar ASN',
          url: 'merchandise/adjustmentv2',
          roles: [PUTAWAY],
          identation: style.identation
        }
      ]
    },

    // PLANNER
    {
      component: undefined,
      name: 'Planner',
      url: '',
      roles: [SUPER_ADMIN],
      items: [
        {
          component: OtInboundPage,
          name: 'OT de Ingreso',
          url: 'planner/inbound',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        },
        // {
        //   component: PlannerPage,
        //   name: 'Gestionar Pedidos',
        //   url: 'planner/oldorder',
        //   roles: [WAREHOUSE_SUPERVISOR],
        //   identation: style.identation
        // },
        {
          component: OrderPage,
          name: 'Gestionar Pedidos',
          url: 'planner/order',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        },
        {
          component: WorkOrderOutboundPage,
          name: 'OT de Salida',
          url: 'workOrderOutbound',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        },
        {
          component: InventoryCheckPage,
          name: 'OT de Mantenimiento',
          url: 'inventoryCheck',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        }
      ]
    },

    // PICKING
    {
      component: undefined,
      name: 'Picking',
      url: '',
      roles: [SUPER_ADMIN],
      items: [
        {
          component: PickingRouteAdminPage,
          name: 'Gestionar Rutas',
          url: 'picking/newadmin',
          roles: [PICKER],
          identation: style.identation
        },
        {
          component: PickingPage,
          name: 'Ruta Picking',
          url: 'picking/route',
          roles: [PICKER],
          identation: style.identation
        },
        {
          component: PickingValidatePage,
          name: 'Validar Ruta',
          url: 'picking/validate',
          roles: [PICKER],
          identation: style.identation
        }
      ]
    },
    // SALIDA DE MERCADERIA
    {
      component: undefined,
      name: 'Salida Mercadería',
      url: '',
      roles: [SUPER_ADMIN],
      items: [
        // {
        //  component: DispatchOtPage,
        //  name: 'Despachar OT',
        //  url: 'merchandise/dispatchot',
        //  roles: [DISPATCHER],
        //  identation: style.identation
        // },
        {
          component: DispatchOtNewPage,
          name: 'Despachar OT',
          url: 'merchandise/newdispatchot',
          roles: [DISPATCHER],
          identation: style.identation
        },
        {
          component: CheckPage,
          name: 'Entrada/Salida Transportista',
          url: 'merchandise/checkinout',
          roles: [DISPATCHER],
          identation: style.identation
        }
      ]
    },

    // REPORTERIA
    {
      component: undefined,
      name: 'Reportes',
      url: '',
      roles: [SUPER_ADMIN],
      items: [
        {
          component: DashBoardPage,
          name: 'Picking',
          url: 'report/picking',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        },
        {
          component: PickingReportPage,
          name: 'Avances Picking',
          url: 'report/pickingworkflow',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        },
        {
          component: FillRatePage,
          name: 'OT',
          url: 'report/fillrate',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        },
        {
          component: WorkOrderDashboardPage,
          name: 'Avances OT',
          url: 'report/workorder',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        }
      ]
    },

    // INVENTARIO
    {
      component: undefined,
      name: 'Inventario',
      url: '',
      roles: [SUPER_ADMIN],
      items: [
        {
          component: NewStockPages,
          name: 'Stock',
          url: 'inventory/stock',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        },
        // {
        //   component: RelocatePage,
        //   name: 'Reubicar Productos',
        //   url: 'inventory/relocate',
        //   roles: [PUTAWAY],
        //   identation: style.identation
        // },
        {
          component: NewRelocatePage,
          name: 'Reubicar Productos',
          url: 'inventory/newrelocate',
          roles: [PUTAWAY],
          identation: style.identation
        },
        {
          component: StockMovementNewPage,
          name: 'Historial de Stock',
          url: 'inventory/stockmovementnew',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        },
        {
          component: PositionAlertsPage,
          name: 'Alertas de Inventario',
          url: 'picking/positionAlerts',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        },
        {
          component: StockReservePage,
          name: 'Stock y Reservas',
          url: 'inventory/stockReserve',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        },
        {
          component: NewProductPage,
          name: 'Catálogo de Productos',
          url: 'inventory/newproduct',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        },
        {
          component: WorkOrderRecallPage,
          name: 'Retiro de Productos',
          url: 'workorderrecall',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        }
      ]
    },

    // LAYOUT
    {
      component: undefined,
      name: 'Layout',
      url: '',
      roles: [SUPER_ADMIN],
      items: [
        {
          component: AlmacenPage,
          name: 'Gestionar Almacén',
          url: 'inventory/warehouse',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation
        },
        {
          component: ZonePage,
          name: 'Gestionar Zona',
          url: 'inventory/zone',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation
        },
        // Se pide ocultar solamente SubZona
        // {
        //   component: SubZonePage,
        //   name: 'Gestionar SubZona',
        //   url: 'inventory/subzone',
        //   roles: ALL_WAREHOUSE_SUP,
        //   identation: style.identation
        // },
        {
          component: PositionPage,
          name: 'Gestionar Posición',
          url: 'inventory/position',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation
        },
        {
          component: TypePositionPage,
          name: 'Gestionar Tipos de Posición',
          url: 'inventory/typeposition',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation
        }
      ]
    },

    // DEVOLUCIONES
    {
      component: undefined,
      name: 'Devoluciones',
      url: '',
      roles: [SUPER_ADMIN],
      items: [
        {
          component: ReturnsPage,
          name: 'Gestionar Devoluciones',
          url: 'returns',
          roles: [PUTAWAY],
          identation: style.identation
        }
      ]
    },
    // CONFIGURACIÓN
    {
      component: undefined,
      name: 'Configuración',
      url: '',
      roles: [SUPER_ADMIN],
      items: [
        {
          component: PreSaleSkuPage,
          name: 'Gestionar Venta en Verde',
          url: 'presalesku',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation
        },
        {
          component: CourierPage,
          name: 'Gestionar Couriers',
          url: 'couriers',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation
        },
        {
          component: WebhookPage,
          name: 'Gestionar Webhooks',
          url: 'webhook',
          roles: [SUPER_ADMIN],
          identation: style.identation
        },
        {
          component: ProductOriginPage,
          name: 'Gestionar Marcas',
          url: 'inventory/productOrigin',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation
        },
        {
          component: TypePriorityPage,
          name: 'Gestionar Prioridades',
          url: 'typePriorities',
          roles: [ADMIN_CONFIGURATOR],
          identation: style.identation
        }
      ]
    },
    {
      component: undefined,
      name: 'Integración Externa',
      url: '',
      roles: [SUPER_ADMIN],
      items: [
        {
          component: ExternalAuditPage,
          name: 'Gestionar Logs',
          url: 'auditlogs',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        },
        {
          component: RestockOrderPage,
          name: 'Reabastecimiento',
          url: 'restockOrder',
          roles: [WAREHOUSE_SUPERVISOR],
          identation: style.identation
        }
      ]
    },
    {
      component: undefined,
      name: 'Ciclicos',
      url: '',
      roles: [SUPER_ADMIN],
      items: [
        {
          component: InventoryCheckHandheldPage,
          name: 'Ciclicos',
          url: 'inventorycheckhh',
          roles: [PUTAWAY],
          identation: style.identation
        }
      ]
    },
    {
      component: KardexPage,
      name: 'Kardex',
      url: 'kardex',
      items: [],
      roles: [SUPER_ADMIN, WAREHOUSE_SUPERVISOR]
    },
    {
      component: UserPage,
      name: 'Gestionar Usuarios',
      url: 'users',
      items: [],
      roles: [SUPER_ADMIN, ADMUSER]
    },
    {
      component: ProcessNew,
      name: 'Procesos',
      url: 'processCheck',
      items: [],
      roles: [SUPER_ADMIN, WAREHOUSE_SUPERVISOR]
    },

    {
      component: ConfigurationPage,
      name: 'Configuración',
      url: 'configuration',
      items: [],
      roles: [SUPER_ADMIN]
    }
  ]
}
